import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {OfficeSummaryConverter} from '../../../../office/api/model/converter/officeSummary.converter';
import {PartnerTypeSummaryConverter} from './partnerTypeSummary.converter';
import {PhoneConverter} from '../../../../common/phone/entity/converter/phone.converter';
import {AdditionalPropertyConverter} from '../../../../common/additional-property/converter/additionalProperty.converter';
import {AccountSummaryConverter} from '../../../../account/common/api.converter/AccountSummary.converter';
import {ExternalIdConverter} from '../../../../common/externalId/api/entity/converter/externalId.converter';
import {PartnerSummaryModel} from '../model/partnerSummary.model';
import {Injectable} from '@angular/core';
import {DateConverter} from "../../../../common/converter/date.converter";
import {UserSummaryConverter} from "../../../../account/modules/user/api/converter/userSummary.converter";


@Injectable({
    providedIn: 'root',
})
export class PartnerSummaryConverter extends HttpModelConverter<PartnerSummaryModel>{

    protected createInstance(): PartnerSummaryModel {
        return new PartnerSummaryModel();
    }

    protected enrichObject(result: PartnerSummaryModel, src: PartnerSummaryModel) {
        result.types = new PartnerTypeSummaryConverter().convertFromArray(src.types);
        // result.mainAddress = new PartnerAddressConverter().convert(src.mainAddress);
        result.office = new OfficeSummaryConverter().convert(src.office);
        // result.mainPerson = new PartnerPersonSummaryConverter(new LovValueSummaryConverter()).convert(src.mainPerson);
        result.phone = new PhoneConverter().convert(src.phone);
        result.officePhone = new PhoneConverter().convert(src.officePhone);
        result.mobilePhone = new PhoneConverter().convert(src.mobilePhone);
        result.additionalProperties = new AdditionalPropertyConverter().convertFromArray(src.additionalProperties);
        result.account = new AccountSummaryConverter().convert(src.account);
        result.externalIds = new ExternalIdConverter().convertFromArray(src.externalIds);
        result.createdAt = new DateConverter().convert(src.createdAt);
        result.createdBy = new UserSummaryConverter().convert(src.createdBy);
    }
}
